import type { IconProps } from "./types";

const SizesIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}: IconProps) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 18}
    height={height || size || 18}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd" transform="translate(1, 1)">
      <g
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path
          strokeLinecap="round"
          d="M4 5.856V3a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h.095"
        />
        <path d="M1 10h10v7H1z" />
      </g>
    </g>
  </svg>
);

export default SizesIcon;
